const CONECCTIONSVIEW = {  
  company: "Companhia",
  typeConnection: "Tipo de conexão",
  motorConnection: "Mecanismo de conexão",
  nameConnection: "Nome da conexão:",
  user: "Do utilizador",
  password: "Senha",
  dataBase: "Base de dados",
  host: "Host",
  idProject: "ID do projeto",
  idProjectGCP: "ID do projeto (GCP)",
  nameInstance: "Nome da instância",
  examplePlaceHolder: "Exemplo: instância:zona",
  update: "Atualizar",
  create: "Para criar",
  restore: "Restaurar",
  cancel: "Cancelar",
  managerConnection: "Gerenciador de conexões",
  selectCompany: "Selecione uma empresa para continuar",
  selectTypeConnection: "Selecione um tipo de conexão",
  selectMotorConnection: "Selecione um mecanismo de conexão para continuar",
  enterNameConnecction: "Digite o nome da conexão",
  manageKeys: "Gerente de Chaves",
  validateNameConnection: "Insira um nome de login válido (pelo menos 3 caracteres)",
  validateNameUser: "Digite um nome de usuário (menos 3 caracteres)",
  validateKeys: "Digite uma senha válida (pelo menos 6 caracteres)",
  validateNameDB: "Insira um nome de banco de dados válido (pelo menos 3 caracteres)",
  host: "Host",
  enterIpHost: "Digite o IP do host.",
  validateIpHost: "Insira um IP válido para o host.",
  pahtConnection: "Caminho de conexão",
  selectFormConecction: "Selecione o formulário de conexão.",
  nameProject: "Nome do projeto",
  validateIdProyect: "Insira o ID do projeto (pelo menos 6 caracteres)",
  nameInstance: "Nome da instância",
  validateInstane: "Insira um nome de instância válido (pelo menos 3 caracteres)",
  errorSaveConnection: "Ocorreu um erro ao salvar a conexão({error})",
  updateConnection: "Conexão atualizada com sucesso!",
  emptyCompanies: "Não há empresas cadastradas.",
  listCompanies: "Lista de empresas",
  _updateConnection: "Atualizando conexão",
  _newConnection: "Nova conexão",

  name: "Nome",
  company: "Companhia",
  type: "Cara",
  actions: "Ações",
  emptyConnections: "Não há conexões registradas.",
  listConnections: "Lista de conexões",
  deleteConnection: "Excluir conexão: {data}",
  advertencie: "Esta opção não pode ser desfeita, tem certeza?",
  accept: "Aceitar",
  titleDeleteConnection: "Excluir conexão",
  errorToDelecteConnection: "Ocorreu um erro ao excluir a conexão",
  actionDisabled: "Ação não disponível no momento"
};

export default { CONECCTIONSVIEW };
